import React from 'react'
import { Autocomplete } from '@material-ui/lab'
import { Checkbox, CircularProgress, TextField } from '@material-ui/core'
import PropTypes from 'prop-types'

const AutoCompleteField = ({
  options = [],
  keyArr = 'id',
  labelKey = 'name',
  labelKeys = [],
  label,
  placeholder,
  limitTags = 1,
  value = '',
  valueKey = '',
  valueKeys = [],
  name = '',
  onChange = () => {},
  fullWidth = false,
  disabled = false,
  isMobile = false,
  multiple = false,
  loading = false,
  error = false,
  helperText = '',
  ...other
}) => {
  const getValue = () => {
    if (valueKey && valueKeys?.length > 0) {
      throw new Error('valueKey and valueKeys are mutually exclusive')
    }
    if (multiple && valueKey && Array.isArray(value)) {
      return options?.filter(item => value.includes(item[valueKey])) || []
    }
    if (multiple && valueKeys?.length > 0 && Array.isArray(value)) {
      const key = valueKeys[0]
      return (
        options?.filter(item => value?.find(vl => vl[key] === item[key])) || []
      )
    }

    if (valueKey) {
      return options?.find(item => item[valueKey] === value) || null
    }
    if (valueKeys?.length > 0 && value && typeof value === 'object') {
      const key = valueKeys[0]
      return options?.find(item => item[key] === value[key]) || null
    }

    return value || null
  }

  const getOptionLabel = option => {
    if (labelKeys?.length > 0 && !!labelKey && labelKey !== 'name') {
      throw new Error('labelKey and labelKeys are mutually exclusive')
    }

    if (labelKeys?.length > 0) {
      return labelKeys?.map(key => option[key]).join(' ') || ''
    }
    return option[labelKey] || ''
  }

  const getOptionSelected = (option, value) => {
    if (multiple && valueKey) {
      return option?.[valueKey] === value?.[valueKey]
    }
    return option?.[keyArr] === value?.[keyArr]
  }

  const handleChange = (event, newValue) => {
    const byValueKey =
      valueKey &&
      (multiple
        ? newValue?.map(item => item?.[valueKey])
        : newValue?.[valueKey])

    const byValueKeys =
      valueKeys?.length > 0 &&
      (multiple
        ? newValue?.map(item => {
            const obj = {}
            valueKeys?.forEach(key => {
              obj[key] = item?.[key] || null
            })
            return obj
          })
        : Object.fromEntries(
            valueKeys?.map(key => [key, newValue?.[key] || null])
          ))

    onChange({
      target: {
        name,
        value: valueKey
          ? byValueKey
          : valueKeys?.length > 0
          ? byValueKeys
          : newValue
      }
    })
  }
  const renderTags = (value, getTagProps) => {
    return (
      <>
        {value?.[0] && (
          <span style={{ paddingLeft: 10 }} {...getTagProps({ index: 0 })}>
            {value?.[0]?.[labelKey]}
          </span>
        )}
        {value?.length > 1 && (
          <span style={{ paddingLeft: 10 }} {...getTagProps({ index: 1 })}>
            +{value?.length - 1}
          </span>
        )}
      </>
    )
  }
  return (
    <Autocomplete
      options={options || []}
      disabled={disabled}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      value={getValue()}
      onChange={handleChange}
      loading={loading}
      {...(multiple
        ? {
            limitTags: -2,
            renderTags,
            renderOption: (option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  color="primary"
                  style={{ marginRight: 2 }}
                  checked={selected}
                />
                {getOptionLabel(option)}
              </React.Fragment>
            )
          }
        : {})}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            ...other.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="primary" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
          InputLabelProps={{
            shrink: true
          }}
        />
      )}
      {...other}
    />
  )
}
export default AutoCompleteField
AutoCompleteField.propTypes = {
  options: PropTypes.array,
  keyArr: PropTypes.string,
  labelKey: PropTypes.string,
  labelKeys: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  fullWidth: PropTypes.bool,
  placeholder: PropTypes.string
}
